module.exports = __webpack_public_path__ + "img/xlph4.5428babf.jpg";